<template>
  <section class="flex level-1" v-touch:swipe.right="swipeRightHandler">   
  
    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Classement</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT-->
    <div class="block__classement content__classement">
      <!-- //TITLE MOBILE -->
      <div class="header classement entete mobile">
        <div class="left">
        <p class="subtitle">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>        
            Rocheteau Patrick
          </PuSkeleton>
        </p>
        </div>
        <div class="cardScore">
          <wrapperRankingScore
          titleLeft="Classement"
          titleRight="Scores"
          objectif="+2"
          :number="4"
          :ofThem="5"
          :scoreNumber="420"
          />
        </div>
      </div>
      <!-- //TITLE MOBILE -->

      <!-- PART MIDDLE -->
      <div class="column-middle">
        <div class="header entete desktop">
          <div class="left">
          <p>Classement</p>
          <p class="subtitle">
            <PuSkeleton :loading="isLoading" :count="1" width='120px'>        
              Rocheteau Patrick
            </PuSkeleton>            
          </p>
          </div>
          <div class="cardScore">
            <wrapperRankingScore
            titleLeft="Classement"
            titleRight="Scores"
            objectif="+2"
            :number="4"
            :ofThem="5"
            :scoreNumber="420"
            />
          </div>
        </div>




        <b-card no-body class="card-big"> 
            <div class="header">
              <h3>Évolution classement</h3>
              <b-button-group>
                <b-button :pressed.sync="week">{{content.btWeek}}</b-button>
                <b-button :pressed.sync="month">{{content.btMonth}}</b-button>
                <b-button :pressed.sync="year">{{content.btYear}}</b-button>
              </b-button-group>
            </div>
            <!-- GRAPHIC -->
            <cardBig class="mt-4"/>
            <!-- GRAPHIC -->
        </b-card>



        <wrapperObjectiveListProductions 
        class="mb-4"
        title="Productions"
        :objectifNumber="50"
        :lists="listsProduction"
        />

        <wrapperObjectiveList 
        class="mb-4"
        title="Bonus"
        :objectifNumber="50"
        :lists="lists"
        />


        <wrapperObjectiveList 
        class="mb-4"
        title="Malus"
        :objectifNumber="20"
        :lists="lists2"
        />

        <wrapperObjectiveListBonus 
        class="mb-4"
        title="Bonus excursion"
        :objectifNumber="78"
        :lists="listsBonus"
        />






        <div class="block__totalPoints">
            <p class="title">Total points</p>
            <p class="number">
              <PuSkeleton :loading="isLoading" :count="1" width='60px'>              
                346
              </PuSkeleton>
            </p>
        </div>

      </div>
      <!-- PART MIDDLE -->



      <!-- PART RIGHT -->
      <b-col sm="12" md="12" class="col-right column-right borderLeft">
        <tabsSidebarRanking />
      </b-col>
      <!-- PART RIGHT -->



    <!-- SIDEBAR MOBILE -->
    <SidebarChallenges class="mobile" />
    <!-- SIDEBAR MOBILE -->
    
    </div>
    <!-- CONTENT-->

  </section>    
</template>


<script>
import { mapGetters } from 'vuex'
import cardBig from '../../../module/card/CardBig'
import wrapperRankingScore from '../../../module/wrapper/wrapperRankingScore'
import wrapperObjectiveList from '../../../module/wrapper/wrapperObjectiveList'
import wrapperObjectiveListProductions from '../../../module/wrapper/wrapperObjectiveListProductions'
import wrapperObjectiveListBonus from '../../../module/wrapper/wrapperObjectiveListBonus'
import tabsSidebarRanking from '../../../module/tabs/TabsSidebarRanking'
// import Navbar from '../../../module/Navbar'
import SidebarChallenges from '../../../module/sidebar/SidebarChallenges'
import utils from '../../../Utils'


export default {
  name:"challengeClassement",
    components:{ 
      cardBig,
      wrapperRankingScore,
      wrapperObjectiveList,
      wrapperObjectiveListProductions,
      wrapperObjectiveListBonus,
      tabsSidebarRanking,
      SidebarChallenges 

    }, 
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },
    data () {
      return {
        content:"",
        isLoading:true,
        week: true,
        month: false,
        year: false,
        isMobile:false,
        chart : {
                labels: [1500,1600,1700,1750,1800],
                datasets: [{ 
                    data: [86,114,106,106,107],
                    borderColor: "rgb(0,106,162)",
                    fill: false,
                    borderDash: [5,10],
                    pointRadius: 0
                  }, { 
                    data: [282,350,411,502,635],
                    borderColor: "rgb(128,128,128)",
                    fill: false,
                    pointRadius: 0
                  }, { 
                    data: [168,170,178,190,203],
                    borderColor: "rgb(0,106,162)",
                    fill: false,
                    pointRadius: 0
                  }
                ]
              },
        lists : [
            {
              title:"Taux de couverture tous produits (hors digital)",
              number:"30",
              label:"Supérieur ou égal à 100%",
              value:"19",
              color:"green"
            }, {
              title:"Taux de couverture tous produits (hors digital)",
              number:"30",
              label:"Supérieur ou égal à 100%",
              value:"59",
              color:""
            }           
          ],
        lists2 : [
            {
              title:"Taux de couverture tous produits (hors digital)",
              number:"300",
              label:"Supérieur ou égal à 100%",
              value:"79",
              color:""
            }, {
              title:"Taux de couverture tous produits (hors digital)",
              number:"30",
              label:"Supérieur ou égal à 100%",
              value:"40",
              color:""
            }           
          ],
        listsBonus : [
            {
              title:"Transparence 2",
              number:"20",
              label:"Du 1er juillet au 17 septembre 2019",
              subLabel:"Arbitrages et transferts Fourgous",
              etiquette:"progress",
              color:""
            }, {
              title:"Transparence 3",
              number:"20",
              label:"Du 1er juillet au 17 septembre 2019",
              subLabel:"Arbitrages et transferts Fourgous",
              etiquette:"done",
              color:""
            }           
          ],
        listsProduction : [
            {
              title:"Montant des cotisations des AN PRO",
              number:"14,00",
              label:"Chiffre d’affaire sans CM",
              value:"11 756",
              color:""
            }, 
            {
              title:"Nombre AN MRP",
              number:"10,00",
              label:"Nombre sans CM",
              value:"",
              valueStrong:"2",
              color:""
            }           
            , {
              title:"Nombre AN Collectives",
              number:"10,00",
              label:"Nombre sans CM",
              label2:"Nombre avec CM",
              valueStrong:"3",
              valueStrong2:"2",
              valueStrongSub:"15,00",
              valueStrongSub2:"10,00",
              value:"",
              color:""
            }           
            , {
              title:"Nombre AN GAV : MT <= 40",
              color:"red",
              icon:'target',
              number:"-",
            }
            , {
              title:"Nombre AN GAV : MT> 150",
              color:"red",
              icon:'target',
              number:"-",
            }
            , {
              title:"Nombre AN MRP",
              number:"10,00",
              label:"Nombre sans CM",
              valueStrong:"2",
              color:""
            }
            , {
              title:"Cash-flow net UC Epargne - Ret..",
              number:"288,00",
              color:"green",
              icon:'target',
              label:"Chiffre d’affaire sans CM",
              value:"11 756",
            }
            , {
              title:"Nombre AN Epargne",
              color:"",
              label:"Nombre sans CMM",
              valueStrong:"2",
              number:"-",
            }         
            , {
              title:"Nombre AN Epargne",
              color:"",
              label:"Nombre sans CMM",
              valueStrong:"19",
              number:"38",
            }         
            ]          
      }
    },
    created (){
      this.content = this.getGeneral;
      this.isMobile = utils.isMobile();
      setTimeout(() => {
        this.isLoading = false;
        // this.majData();
      },2000) ;
    },   
    mounted (){
      if(!this.isMobile){
        this.onresize();  
        window.addEventListener('resize', this.onresize)
      }
    }, 
    methods : {    
      goBack() {
        this.$store.dispatch('goBack')
        this.$router.push({name: "challengesHome"});  
      },
      swipeRightHandler () {
          this.goBack();
      },
      onresize(){
        let $target = document.querySelector('.block__classement .block__totalPoints');
        let $origine = document.querySelector('.block__classement .column-middle');
        let $info = $origine.getBoundingClientRect();
        let $width = $info.width;
        $target.style.width = (parseInt($width) - parseInt(40)) + 'px';
      }              
    }
};
</script>
